type RelayNetworkError = Error & {
  source?: {
    errors?: ReadonlyArray<{ extensions?: { code?: string } }> | null;
  };
};

export const isGraphQLAuthorizationFailure = (error: unknown): boolean => {
  if (!(error instanceof Error) || error.name !== 'RelayNetwork') return false;

  // Relay keeps the original GraphQL errors when a response contains no data.
  const errors = (error as RelayNetworkError).source?.errors;
  return !!errors?.length && errors.every(graphQLError => graphQLError?.extensions?.code === 'AUTH_NOT_AUTHORIZED');
};
